module.exports = __webpack_public_path__ + "static/img/周边设计.9b2a92c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10004/周边设计.png
// module id = VGAH
// module chunks = 1